import avatar from "@assets/img/defaultAvatar.png";

import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";

import Skeleton from "react-loading-skeleton";
import { Card } from "@components/cards/card";
import { formatName } from "@hooks/functions/formatName";
import { Input } from "@components/forms/input";
import { Masks } from "@hooks/functions/Masks";
import { Button } from "@components/buttons/button";

interface IsAccountLoading {
  info: boolean;
}

const masks = new Masks();
export const Account = () => {
  const navigate = useNavigate();
  const { customer } = ZuAuthStore();

  const [isLoading, setIsLoading] = useState<IsAccountLoading>({
    info: false,
  });

  return (
    <>
      {/* Account Summary */}
      <div className="row d-flex">
        {/* Perfil Summary */}
        <div className="col-md-4 d-flex">
          <Card className="position-relative flex-fill">
            <div className="card-header">
              <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                  <div>Cadastro</div>
                  <div>
                    <span
                      className={`rounded-circle d-inline-block me-2 bg-success`}
                      style={{ width: 15, height: 15 }}
                      title={`Ativo`}
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body">
              {isLoading.info ? (
                <Skeleton count={1} />
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    {/* Logo | Avatar */}
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <div className="avatar avatar-xxl">
                        <img
                          src={avatar}
                          alt=""
                          className="avatar-img rounded-circle"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mt-3">
                    {/* Custoemr Info */}
                    <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                      <h5 className="fw-bold">
                        {formatName(
                          customer?.customer?.name
                            ? customer?.customer?.name
                            : ``
                        )}
                      </h5>
                      <span className="d-flex align-items-center gap-1">
                        E-mail Informado:{" "}
                        <span
                          className={`rounded-circle d-inline-block ms-1 bg-${`success`}`}
                          style={{ width: 13, height: 13 }}
                          title={`Informado`}
                        />
                      </span>
                      <span>
                        Cadastro:{" "}
                        {customer?.customer?.createdAt
                          ? dayjs(customer?.customer?.createdAt).format(
                              "DD/MM/YYYY [às] HH:MM:ss"
                            )
                          : "~"}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>

        {/* Important Info */}
        <div className="col-md-8 d-flex">
          <Card className="position-relative flex-fill">
            <div className="card-header">
              <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                  <div>Informações Pessoais</div>
                </div>
              </div>
            </div>
            <div className="card-body">
              {isLoading.info ? (
                <Skeleton count={3} />
              ) : (
                <div className="row">
                  <div className="col-md-6">
                    <Input
                      label="Nome"
                      placeholder="Nome Completo"
                      animated
                      value={formatName(customer?.customer?.name || "")}
                      disabled={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="E-mail"
                      placeholder="Seu e-mail de cadastro"
                      animated
                      value={customer?.customer?.email || ""}
                      disabled={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="CPF"
                      placeholder="Seu celular de cadastro"
                      animated
                      value={masks.cpf(customer?.customer?.document || "")}
                      disabled={true}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer">
              <div className="text-end pb-2">
                <Button
                  className="btn btn-info text-white px-3 mt-2"
                  onClick={() => {
                    navigate("/password/change");
                  }}
                >
                  Alterar Senha
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};
